<template>
  <q-dialog
    :value="isOpen"
    :presistent="presistent"
    :maximized="!noMaximized"
    :transition-show="transitionShow"
    :transition-hide="transitionHide"
    :content-class="{ scrollable }"
    v-bind="$attrs"
    no-focus
    @mouseup.prevent="() => {}"
    @input="$emit('close')"
    @show="$emit('show')"
    @hide="$emit('hide', $event)"
  >
    <div
      :class="parentClass"
      @mousedown.self="$emit('close')"
    >
      <q-card
        :class="['modal-content q-mx-auto', contentClass]"
        :style="contentStyle"
      >
        <q-card-section
          v-if="showHeader"
          :class="['row items-center justify-between q-pl-lg q-pr-md modal-header', headerClass]"
        >

          <div class="row items-center full-width">
            <div
              v-if="title"
              class="text-18-600 q-mr-md col"
            >
              {{ title }}
            </div>
            <slot name="header"/>
          </div>

          <q-btn
            v-if="showCloseBtn"
            v-close-popup
            dense
            flat
            size="12.5px"
          >
            <q-icon
              name="close"
              class="close-icon"
            />
          </q-btn>
        </q-card-section>

        <q-card-section :class="['q-pa-none modal-body', modalBodyClass]">
          <slot/>
        </q-card-section>

        <q-card-actions
          v-if="$slots.footer"
          class="modal-footer q-pa-none"
        >
          <slot name="footer"/>
        </q-card-actions>
      </q-card>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'AppModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    noMaximized: {
      type: Boolean,
      default: false,
    },
    showCloseBtn: {
      type: Boolean,
      default: false,
    },
    contentStyle: {
      type: [String, Object],
      default: undefined,
    },
    contentClass: {
      type: [String, Object],
      default: undefined,
    },
    parentClass: {
      type: [String, Object, Array],
      default: 'bg-transparent shadow-0 q-pa-md-lg',
    },
    headerClass: {
      type: [String, Object, Array],
      default: 'bg-grey-6',
    },
    modalBodyClass: {
      type: [String, Object, Array],
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    presistent: {
      type: Boolean,
      default: false,
    },
    transitionShow: {
      type: String,
      default: 'jump-down',
    },
    transitionHide: {
      type: String,
      default: 'jump-up',
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close'],
  computed: {
    showHeader() {
      return this.title || this.showCloseBtn || this.$slots.header;
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1024px) {
  .modal-header {
    height: 100% !important;
  }
}

.modal-wrapper {
  padding: 60px;
  z-index: 3002;
  min-width: 300px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.close-icon {
  color: $secondary;
  width: 15px;
  height: 15px;
}

.dialog__inner {
  overflow: scroll;
}

.modal-header {
  width: 100%;
  border-bottom: thin solid rgba(0, 36, 82, 0.12);
  flex-wrap: nowrap;
}

</style>

<style lang="scss">
.scrollable {
  .q-dialog__inner {
    & > div {
      height: 100%;
    }
  }
}

.q-dialog__inner {
  padding: 0;

  & > div {
    max-height: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
